// extracted by mini-css-extract-plugin
export var statItem = "_kr-1";
export var statsRow = "_kr-0";